// /dev/Authors/UserManagementPage.js

import React, { useState } from "react";
import styles from "./userManagement.module.css";
import UserList from "./UserList";
import UserDetailed from "./UserDetailed";

import { useAuth } from "../../Context/AuthContext";
import { fetchUserDetailed } from "../../Api/Backend/User";


export default function UserManagementPage() {
  const auth = useAuth();

  const [activeTab, setActiveTab] = useState("list"); // 'list' or 'form'
  const [selectedEntry, setSelectedEntry] = useState(null); // The user/author to edit

  // Switch to form for editing an existing entry
  const handleEditEntry = async (entry) => {
    if (!entry?.userId) {
      alert("Clicked entry returned no userId");
      return;
    }
    
    await fetchUserDetailed({
      auth: auth,
      userId: entry.userId,
      onSuccess: (data) => {
        setSelectedEntry(data);
        setActiveTab("form");
      },
      onError: (error) => {
        console.error("Error fetching detailed user data:", error);
      }
    });
  };

  // Switch to form for creating a new entry
  const handleAddNew = () => {
    setSelectedEntry(null); // Clear any previously selected entry
    setActiveTab("form");
  };

  // Switch back to the list after a successful save/update
  const handleFormSuccess = () => {
    setSelectedEntry(null);
    setActiveTab("list");
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.tabContainer}>
        <div className={styles.tabSelectors}>
          <div
            className={`${styles.tab} ${
              activeTab === "list" ? styles.active : ""
            }`}
            onClick={() => setActiveTab("list")}
          >
            사용자
          </div>
          <div
            className={`${styles.tab} ${
              activeTab === "form" ? styles.active : styles.disabled
            }`}
          >
            편집
          </div>
        </div>
        {activeTab === "list" && (
          <button className={styles.addButton} onClick={handleAddNew}>
            +
          </button>
        )}
      </div>

      <div className={styles.contentArea}>
        {activeTab === "list" ? (
          <UserList onEditEntry={handleEditEntry} />
        ) : (
          <UserDetailed
            selectedEntry={selectedEntry}
            onSuccessHandle={handleFormSuccess}
          />
        )}
      </div>
    </div>
  );
}
